"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemApi = exports.SystemApiFactory = exports.SystemApiFp = exports.SystemApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SystemApi - axios parameter creator
 * @export
 */
const SystemApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: CheckUnvalidatedImages - Difficulty: 4 - Roles can execute: ROLE_SYSTEM
         * @summary Henüz valide edilmemiş kullanıcı avatarlarının validasyonunu belirli aralıklarla kontrol eder. Bu işlemin yapılabilmesi için ImageService ve NsfwService kullanılması gerekmektedir.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnvalidatedImages: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/system/check_unvalidated_images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ExportAccountData - Difficulty: 5 - Roles can execute: ROLE_SYSTEM
         * @summary Scheduler üzerinden kullanıcı verisini dışarı aktarma işini yapmak için çağırılan metoddur. Önemli Not: Gerekmemesi durumunda endpoint halinde kalmaması iyi olur. Lütfen implementasyondan önce kontrol ediniz. Veritabanında kullanıcıyla herhangi bir şekilde bağlantı kurulabilen tüm bilgiler çıktılanmalıdır.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAccountData: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/system/export_account_data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: PaymentHook - Difficulty: 3 - Roles can execute: everybody
         * @summary TODO Biraz daha detayları araştırılması gerekiyor. İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
         * @param {string} xIYZSIGNATURE X-IYZ-SIGNATURE
         * @param {PaymentHookCommand} [paymentHookCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentHook: (xIYZSIGNATURE, paymentHookCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xIYZSIGNATURE' is not null or undefined
            (0, common_1.assertParamExists)('paymentHook', 'xIYZSIGNATURE', xIYZSIGNATURE);
            const localVarPath = `/api/system/payment_hook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xIYZSIGNATURE !== undefined && xIYZSIGNATURE !== null) {
                localVarHeaderParameter['X-IYZ-SIGNATURE'] = String(xIYZSIGNATURE);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(paymentHookCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: PaymentSuccess - Difficulty: 3 - Roles can execute: everybody
         * @summary İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
         * @param {string} token token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentSuccess: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('paymentSuccess', 'token', token);
            const localVarPath = `/api/system/payment_response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            if (token !== undefined) {
                localVarFormParams.set('token', token);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: RevenueCatWebhook - Difficulty: 5 - Roles can execute: everybody
         * @summary Revenue cat üzerinden oluşan işlemlerin kayıtlarını işler.
         * @param {string} authorization Authorization
         * @param {RevenueCatWebhookCommand} [revenueCatWebhookCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueCatWebhook: (authorization, revenueCatWebhookCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'authorization' is not null or undefined
            (0, common_1.assertParamExists)('revenueCatWebhook', 'authorization', authorization);
            const localVarPath = `/api/system/revenue_cat_webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(revenueCatWebhookCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SystemApiAxiosParamCreator = SystemApiAxiosParamCreator;
/**
 * SystemApi - functional programming interface
 * @export
 */
const SystemApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SystemApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: CheckUnvalidatedImages - Difficulty: 4 - Roles can execute: ROLE_SYSTEM
         * @summary Henüz valide edilmemiş kullanıcı avatarlarının validasyonunu belirli aralıklarla kontrol eder. Bu işlemin yapılabilmesi için ImageService ve NsfwService kullanılması gerekmektedir.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnvalidatedImages(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkUnvalidatedImages(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ExportAccountData - Difficulty: 5 - Roles can execute: ROLE_SYSTEM
         * @summary Scheduler üzerinden kullanıcı verisini dışarı aktarma işini yapmak için çağırılan metoddur. Önemli Not: Gerekmemesi durumunda endpoint halinde kalmaması iyi olur. Lütfen implementasyondan önce kontrol ediniz. Veritabanında kullanıcıyla herhangi bir şekilde bağlantı kurulabilen tüm bilgiler çıktılanmalıdır.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAccountData(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportAccountData(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: PaymentHook - Difficulty: 3 - Roles can execute: everybody
         * @summary TODO Biraz daha detayları araştırılması gerekiyor. İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
         * @param {string} xIYZSIGNATURE X-IYZ-SIGNATURE
         * @param {PaymentHookCommand} [paymentHookCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentHook(xIYZSIGNATURE, paymentHookCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentHook(xIYZSIGNATURE, paymentHookCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: PaymentSuccess - Difficulty: 3 - Roles can execute: everybody
         * @summary İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
         * @param {string} token token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentSuccess(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentSuccess(token, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: RevenueCatWebhook - Difficulty: 5 - Roles can execute: everybody
         * @summary Revenue cat üzerinden oluşan işlemlerin kayıtlarını işler.
         * @param {string} authorization Authorization
         * @param {RevenueCatWebhookCommand} [revenueCatWebhookCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueCatWebhook(authorization, revenueCatWebhookCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revenueCatWebhook(authorization, revenueCatWebhookCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SystemApiFp = SystemApiFp;
/**
 * SystemApi - factory interface
 * @export
 */
const SystemApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SystemApiFp)(configuration);
    return {
        /**
         * Operation Id: CheckUnvalidatedImages - Difficulty: 4 - Roles can execute: ROLE_SYSTEM
         * @summary Henüz valide edilmemiş kullanıcı avatarlarının validasyonunu belirli aralıklarla kontrol eder. Bu işlemin yapılabilmesi için ImageService ve NsfwService kullanılması gerekmektedir.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnvalidatedImages(body, options) {
            return localVarFp.checkUnvalidatedImages(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ExportAccountData - Difficulty: 5 - Roles can execute: ROLE_SYSTEM
         * @summary Scheduler üzerinden kullanıcı verisini dışarı aktarma işini yapmak için çağırılan metoddur. Önemli Not: Gerekmemesi durumunda endpoint halinde kalmaması iyi olur. Lütfen implementasyondan önce kontrol ediniz. Veritabanında kullanıcıyla herhangi bir şekilde bağlantı kurulabilen tüm bilgiler çıktılanmalıdır.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAccountData(body, options) {
            return localVarFp.exportAccountData(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: PaymentHook - Difficulty: 3 - Roles can execute: everybody
         * @summary TODO Biraz daha detayları araştırılması gerekiyor. İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
         * @param {string} xIYZSIGNATURE X-IYZ-SIGNATURE
         * @param {PaymentHookCommand} [paymentHookCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentHook(xIYZSIGNATURE, paymentHookCommand, options) {
            return localVarFp.paymentHook(xIYZSIGNATURE, paymentHookCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: PaymentSuccess - Difficulty: 3 - Roles can execute: everybody
         * @summary İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
         * @param {string} token token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentSuccess(token, options) {
            return localVarFp.paymentSuccess(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: RevenueCatWebhook - Difficulty: 5 - Roles can execute: everybody
         * @summary Revenue cat üzerinden oluşan işlemlerin kayıtlarını işler.
         * @param {string} authorization Authorization
         * @param {RevenueCatWebhookCommand} [revenueCatWebhookCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueCatWebhook(authorization, revenueCatWebhookCommand, options) {
            return localVarFp.revenueCatWebhook(authorization, revenueCatWebhookCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SystemApiFactory = SystemApiFactory;
/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
class SystemApi extends base_1.BaseAPI {
    /**
     * Operation Id: CheckUnvalidatedImages - Difficulty: 4 - Roles can execute: ROLE_SYSTEM
     * @summary Henüz valide edilmemiş kullanıcı avatarlarının validasyonunu belirli aralıklarla kontrol eder. Bu işlemin yapılabilmesi için ImageService ve NsfwService kullanılması gerekmektedir.
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    checkUnvalidatedImages(body, options) {
        return (0, exports.SystemApiFp)(this.configuration).checkUnvalidatedImages(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ExportAccountData - Difficulty: 5 - Roles can execute: ROLE_SYSTEM
     * @summary Scheduler üzerinden kullanıcı verisini dışarı aktarma işini yapmak için çağırılan metoddur. Önemli Not: Gerekmemesi durumunda endpoint halinde kalmaması iyi olur. Lütfen implementasyondan önce kontrol ediniz. Veritabanında kullanıcıyla herhangi bir şekilde bağlantı kurulabilen tüm bilgiler çıktılanmalıdır.
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    exportAccountData(body, options) {
        return (0, exports.SystemApiFp)(this.configuration).exportAccountData(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: PaymentHook - Difficulty: 3 - Roles can execute: everybody
     * @summary TODO Biraz daha detayları araştırılması gerekiyor. İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
     * @param {string} xIYZSIGNATURE X-IYZ-SIGNATURE
     * @param {PaymentHookCommand} [paymentHookCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    paymentHook(xIYZSIGNATURE, paymentHookCommand, options) {
        return (0, exports.SystemApiFp)(this.configuration).paymentHook(xIYZSIGNATURE, paymentHookCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: PaymentSuccess - Difficulty: 3 - Roles can execute: everybody
     * @summary İyzico üzerinde satın alım tamamlandıktan sonra İyzico\'nun müşteriyi yönlendireceği url\'dir. Gelen token kayıt altına alındıktan sonra kullanıcı sitenin anasayfasına yönlendirilecektir.
     * @param {string} token token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    paymentSuccess(token, options) {
        return (0, exports.SystemApiFp)(this.configuration).paymentSuccess(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: RevenueCatWebhook - Difficulty: 5 - Roles can execute: everybody
     * @summary Revenue cat üzerinden oluşan işlemlerin kayıtlarını işler.
     * @param {string} authorization Authorization
     * @param {RevenueCatWebhookCommand} [revenueCatWebhookCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    revenueCatWebhook(authorization, revenueCatWebhookCommand, options) {
        return (0, exports.SystemApiFp)(this.configuration).revenueCatWebhook(authorization, revenueCatWebhookCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SystemApi = SystemApi;
